import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore'
import { db } from '../../lib/init-firebase'
import {useParams} from "react-router-dom"

function BlogDetails() {

  const {blogKey} = useParams()

  const [blogs, setBlogs] = useState([])

  useEffect(() => {
    getBlogs()
  }, [])

  useEffect(() => { 
    console.log(blogs)
  }, [blogs])

  function getBlogs() {

    const blogsQuery = query(collection(db, 'blogs'),  where('key', '==',  blogKey))
    
    getDocs(blogsQuery).then(response => {
      const blogs = response.docs.map(doc => ({
        data: doc.data(), 
        id: doc.id,
      }))

      setBlogs(blogs)
    }).catch(error => console.log(error.message))
  }

  if(blogs[0] == null) {
    return (
      <h1>loading...</h1>
    );
  } else {
    return (
      <div className='cards'>
        <h1>{blogs[0].data.title}</h1>
        <div>
        <div dangerouslySetInnerHTML={{ __html: blogs[0].data.content }} />
        </div>
      </div>
    );
  }


}

export default BlogDetails;
